import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Instagram, MessageCircle, Mail, MapPin } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary-navy text-white">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2"
          >
            <h3 className="text-2xl font-bold mb-4">Yüksekkare</h3>
            <p className="text-gray-300 mb-6 max-w-md">
              Ankara'nın önde gelen drone fotoğrafçılığı ve videografi şirketi.
              Profesyonel hizmetlerimizle anılarınızı ölümsüzleştiriyoruz.
            </p>
            <div className="flex space-x-4">
              <motion.a
                href="https://instagram.com/yuksekkare"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1 }}
                className="bg-primary-orange p-3 rounded-full hover:bg-orange-600 transition-colors"
              >
                <Instagram size={20} />
              </motion.a>
              <motion.a
                href="https://wa.me/+905396768149"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1 }}
                className="bg-green-600 p-3 rounded-full hover:bg-green-700 transition-colors"
              >
                <MessageCircle size={20} />
              </motion.a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="text-lg font-semibold mb-4">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Portfolyo
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  İletişim
                </Link>
              </li>
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-lg font-semibold mb-4">İletişim</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin size={16} className="text-primary-orange" />
                <span className="text-gray-300">Ankara, Türkiye</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-primary-orange" />
                <a
                  href="mailto:info@yuksekkare.com"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  info@yuksekkare.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <MessageCircle size={16} className="text-primary-orange" />
                <a
                  href="https://wa.me/+905396768149"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  +90 539 676 81 49
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="border-t border-gray-700 mt-8 pt-8 text-center"
        >
          <p className="text-gray-400">
            © 2024 Yüksekkare. Tüm hakları saklıdır.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
